<template>
    <div class="conversation-item">
        <img :src="conversation.from_user.avatar.src" mode="aspectFit"
        class="conversation-item__avatar"/>
        <div class="conversation-item-info">
            <div class="conversation-item__title">
                <div class="conversation-item__username">{{conversation.from_user.username}}</div>
                <div class="conversation-item__time">{{conversation.format_create_time}}</div>
            </div>
            <div class="conversation-item__content card">
                <div class="conversation-item__context">
                    <div>{{conversation.message}}</div>
                </div>
                <div class="conversation-item__gallery" v-if="conversation.photos.length > 0">
                    <div
                    class="conversation-item__gallery_item"
                    v-for="(photo, index) in conversation.photos"
                    :key="index"
                    @click="browse(index)">
                        <img
                        :src="photo.medium"
                        class="conversation-item__gallery_poster"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swiper from '@/mixins/swiper'

    export default {
        props: ['conversation'],
        mixins: [swiper],
        methods: {
            browse (index) {
                this.view(index, this.conversation.photos.map(photo => {
                    return {
                        src: photo.src,
                        width: photo.width,
                        height: photo.height
                    }
                }))
            }
        }
    }
</script>

<style lang="less" scoped>
    .conversation-item {
        display: flex;
        margin: 0 15px;
        margin-top: 0px;
        margin-bottom: 15px;
        .conversation-item__avatar {
            border-radius: 100%;
            width: 36px;
            height: 36px;
            margin-right: 15px;
        }
        .conversation-item-info {
            flex: 1;
            .conversation-item__title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 10px;
            }
            .conversation-item__time {
                font-size: 9pt;
                color: #999;
            }
            .conversation-item__username {
                font-size: 10pt;
            }
            .conversation-item__content {
                border-radius: 15px;
                padding: 15px;
                font-size: 11pt;
            }
        }
    }

    .conversation-item__gallery {
        overflow: hidden;
        margin-top: 10px;
        .conversation-item__gallery_item {
            position: relative;
            float: left;
            width: calc(33% - 15px);
            padding-bottom: calc(33% - 15px);
            border-radius: 4px;
            margin-right: 5px;
            margin-bottom: 5px;
            overflow: hidden;
            .conversation-item__gallery_poster {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
            }
        }
    }
</style>


